import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const EBillingService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  // legacy ebilling implementation
  service.getEbillCustomers = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/ebill/search${queryString}`, {
      headers,
    });
  };

  // legacy ebilling implementation
  service.unenrollCustomer = (eBillingHistoryId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/ebill/unenroll`, {
      eBillingHistoryId,
    }, {
      headers,
    });
  };

  service.searchEbillingEnrollments = (searchFields) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const queryString = UriUtils.toQueryString(searchFields);
    return axios.get(`${BASE_URL}/ebillingEnrollments/search${queryString}`, {
      headers,
    });
  };

  service.searchTrialNotifications = (searchFields) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const queryString = UriUtils.toQueryString(searchFields);
    return axios.get(`${BASE_URL}/trial-notifications/search${queryString}`, {
      headers,
    });
  };

  service.updateEbillingEnrollment = ({ ebillingEnrollmentId, ebillingEnrollmentStatus, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const reqestBody = { ebillingEnrollmentStatus, };
    return axios.put(`${BASE_URL}/ebillingEnrollments/${ebillingEnrollmentId}`, reqestBody, {
      headers,
    });
  };

  service.triggerEbills = (serviceOfferingId, request = {}) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/ebill/send`, {
      serviceOfferingId,
      request,
    }, {
      headers,
    });
  };

  service.triggerTrialEbills = (serviceOfferingId, request = {}) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/ebill/trial-send`, {
      serviceOfferingId,
      request,
    }, {
      headers,
    });
  };

  return service;
})();

export default EBillingService;
